"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = exports.APIUrl = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var react_2 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var polished_1 = require("polished");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_application_1 = require("@ryerson/frontend.application");

var BarcodeResultsContent_1 = require("./BarcodeResultsContent");

var ScanResultItem_1 = require("./ScanResultItem");

var gatsby_1 = require("gatsby");

var Constants_1 = require("../../common/Constants");

var APIUrl;

(function (APIUrl) {
  APIUrl["BARCODE_SEARCH"] = "/api/items/v1/protected/items/barcode/";
})(APIUrl || (exports.APIUrl = APIUrl = {}));

exports.Divider = styled_1.default.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tborder-top: 1px solid ", ";\n\topacity: 0.1;\n\tmargin-bottom: 23px;\n"])), function (props) {
  return props.color;
});

var barcodeResultsWrapper = function barcodeResultsWrapper(props) {
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\tposition: relative;\n\tz-index: 10;\n\twidth: 100%;\n"])), props.background);
};

var closeButton = function closeButton(props) {
  return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 50px;\n\theight: 50px;\n\tborder-left: 1px solid ", ";\n"])), (0, polished_1.rgba)(props.color, 0.1));
};

var closeButtonWrapper = function closeButtonWrapper(props) {
  return (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tbackground-color: ", ";\n"])), props.color);
};

var iconStyles = (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tposition: relative;\n\ttop: 4px;\n\tmargin-right: 10px;\n"])));

var mainContainerStyles = function mainContainerStyles(props) {
  return (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t@media only screen and (max-width: ", ") {\n\t\tleft: ", ";\n\t\twidth: 100%;\n\t\ttransition: left 0.3s linear;\n\t\tposition: absolute;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t\tz-index: 999;\n\t\tdisplay: ", ";\n\t}\n"])), props.breakpoint, props.isActive ? "0%" : "-100%", props.isActive ? "block" : "none");
};

var BarcodeScanResults = function BarcodeScanResults(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      scannedBarcode = _ref.scannedBarcode,
      storeDirectory = _ref.storeDirectory,
      openBarcodeScanResults = _ref.openBarcodeScanResults,
      handleClose = _ref.handleClose,
      purchaseOrderNumber = _ref.purchaseOrderNumber;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      lighterGray = _theme$colors$primary.lighterGray,
      darkGray = _theme$colors$primary.darkGray;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      language = _ref3.localization.language,
      axiosInstance = _ref3.axiosInstance;

  var _ref4 = (0, react_1.useState)(""),
      _ref5 = _slicedToArray(_ref4, 2),
      bodyStyles = _ref5[0],
      setBodyStyles = _ref5[1];

  var _ref6 = (0, react_1.useState)(function () {
    var currVal = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.barcodeScanResults);
    return currVal === "true" ? true : false;
  }),
      _ref7 = _slicedToArray(_ref6, 2),
      isActive = _ref7[0],
      setIsActive = _ref7[1];

  var _ref8 = (0, react_1.useState)([]),
      _ref9 = _slicedToArray(_ref8, 2),
      barcodeScanResults = _ref9[0],
      setBarcodeScanResults = _ref9[1];

  var _react_1$default$useS = react_1.default.useState(true),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      scanResultsLoading = _react_1$default$useS2[0],
      setScanResultsLoading = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      scanError = _react_1$default$useS4[0],
      setScanError = _react_1$default$useS4[1];

  var content = BarcodeResultsContent_1.BarcodeResultsContent[language] || BarcodeResultsContent_1.BarcodeResultsContent.en;
  (0, react_1.useEffect)(function () {
    var body = document === null || document === void 0 ? void 0 : document.querySelector("body");

    if (openBarcodeScanResults === true) {
      scannedBarcode && getBarcodeScanResults(scannedBarcode);
      setIsActive(true);
      setBodyStyles((body === null || body === void 0 ? void 0 : body.getAttribute("style")) || "");
      sessionStorage.setItem(frontend_common_1.SessionItems.barcodeScanResults, "true");
    } else {
      setIsActive(false);
      sessionStorage.setItem(frontend_common_1.SessionItems.barcodeScanResults, "false");
    }

    return function () {
      body && body.setAttribute("style", bodyStyles);
    };
  }, [openBarcodeScanResults]);

  var getBarcodeScanResults = function getBarcodeScanResults(barcode) {
    axiosInstance.get("".concat(APIUrl.BARCODE_SEARCH + barcode)).then(function (response) {
      if ((0, frontend_common_1.isAxiosError)(response) || response.status !== 200 || response.data.length === 0) {
        throw response;
      }

      setBarcodeScanResults(response.data);
      setScanResultsLoading(false);
    }).catch(function (err) {
      console.warn(err);
      setScanResultsLoading(false);
      setScanError(true);
    });
  };
  /**
   * When user reviews the scan results and accepts them, this function is called.
   *
   * The function saves the scan results into variable `urlSearchParams`, and then determines
   * navigates to the store.
   */


  var onContinueClick = function onContinueClick(item) {
    var urlSearchParams = new URLSearchParams(); // Since quantity==0 is a valid value, we need to check for undefined or null

    if ("quantity" in item && !!item.quantity) {
      urlSearchParams.append("quantity", item.quantity.toString());
    }

    if ("quantityUOM" in item && !!item.quantityUOM) {
      urlSearchParams.append("quantityUom", item.quantityUOM.toString());
    }

    if ("pricingUOM" in item && !!item.pricingUOM) {
      urlSearchParams.append("priceUom", item.pricingUOM.toString());
    }

    if ("altPartNumber" in item && !!item.altPartNumber) {
      urlSearchParams.append("altPartNumber", item.altPartNumber.toString());
    }

    setIsActive(false);
    "customerReferenceNumber" in item && !!item.customerReferenceNumber && urlSearchParams.append("customerReferenceNumber", item.customerReferenceNumber.toString());
    "headerPurchaseOrder" in item && !!item.headerPurchaseOrder && urlSearchParams.append("headerPurchaseOrder", item.headerPurchaseOrder.toString());
    "linePurchaseOrder" in item && !!item.linePurchaseOrder && urlSearchParams.append("linePurchaseOrder", item.linePurchaseOrder.toString());
    var newUrl = "/products/".concat(item.id, "?").concat(urlSearchParams.toString());

    if (storeDirectory !== Constants_1.STORE) {
      return (0, gatsby_1.navigate)(newUrl);
    } else {
      window.location.href = storeDirectory + newUrl;
    }
  };

  return (0, jsx_runtime_1.jsx)("div", {
    css: mainContainerStyles({
      isActive: isActive,
      breakpoint: theme.breakpoints.lg
    }),
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: className,
      direction: "column",
      style: barcodeResultsWrapper({
        background: lighterGray
      }),
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        style: closeButtonWrapper({
          color: darkGray
        }),
        justifyContent: "space-between",
        children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          alignItems: "center",
          onClick: function onClick() {
            return handleClose(true, true);
          },
          css: {
            marginLeft: "20px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            size: "xs",
            label: "",
            circleLabelOrient: "right",
            onClick: function onClick() {
              return handleClose(true, true);
            },
            shape: "circle",
            leftIcon: "chevron-left",
            background: white,
            variant: "outline"
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            style: (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tmargin-left: 15px;\n\t\t\t\t\t\t\t"]))),
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              size: "lg",
              color: white,
              children: content.backButton
            })
          })]
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          justifyContent: "flex-end",
          children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            justifyContent: "center",
            alignItems: "center",
            style: closeButton({
              color: white
            }),
            onClick: function onClick() {
              setScanError(false);
              handleClose(true);
            },
            children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              icon: "close",
              size: "sm",
              onClick: function onClick() {
                setScanError(false);
                handleClose(true);
              },
              color: white
            })
          })
        })]
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        direction: "column",
        css: {
          margin: "27px 20px"
        },
        children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            variant: "h3",
            weight: "bolder",
            css: {
              marginBottom: "16px"
            },
            children: content.title
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              size: "md",
              color: darkGray,
              children: content.subTitle
            })
          })]
        }), scanResultsLoading ? (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "center",
          css: {
            marginTop: "30px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            css: iconStyles,
            icon: "warning",
            size: "sm",
            color: "tertiary"
          }), content.loading]
        }) : scanError ? (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "center",
          css: {
            marginTop: "30px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            css: iconStyles,
            icon: "error",
            size: "sm",
            color: "tertiary"
          }), content.error]
        }) : barcodeScanResults.map(function (item, index) {
          return (0, jsx_runtime_1.jsx)("div", {
            children: (0, jsx_runtime_1.jsx)(ScanResultItem_1.ScanResultItem, {
              content: content,
              onContinueClick: onContinueClick,
              item: item,
              index: index
            })
          }, index);
        })]
      })]
    })
  });
};

exports.default = BarcodeScanResults;